import React from 'react';
import localeCopy from './localeCopy';
import utilLocaleCopy from '@Utilities/services/localization/localeCopy';

export const LocalizationContext = React.createContext({});

export const longLocaleNames = {
  'en-US': 'English',
  'fr-CA': 'French'
};

function getMergedLocaleCopy() {
  const localeCopyMerged = {};

  const allLocales = new Set([...Object.keys(localeCopy), ...Object.keys(utilLocaleCopy)]);

  allLocales.forEach(locale => {
    localeCopyMerged[locale] = {
      ...(utilLocaleCopy[locale] || {}),
      ...(localeCopy[locale] || {})
    };
  });

  return localeCopyMerged;
}

export function getLocalizedCopy(locale = 'en-US') {
  return getMergedLocaleCopy()[locale] || localeCopy[locale] || {};
}

export function normalizeLocale(locale) {
  if (!locale) {
    locale = 'en-US';
  } else {
    if (locale.indexOf('en') !== -1) {
      locale = 'en-US';
    } else if (locale.indexOf('fr') !== -1) {
      locale = 'fr-CA';
    } else {
      locale = 'en-US';
    }
  }

  return locale;
}
